const FeeBase = {
  SalaryBase: "Lønnsgrunnlag",
  Turnover: "Omsetning",
  Other: "Annet",
};

export default FeeBase;
